/** `true` para links que saem do site (abrem em nova aba). */
export function isExternalHref(href: string): boolean {
  return /^(https?:)?\/\//.test(href) || href.startsWith("mailto:") || href.startsWith("tel:")
}

/**
 * Rola suavemente ate uma ancora interna (`#secao`).
 *
 * O offset do header fixo nao e tratado aqui: ele vem da regra `[id] {
 * scroll-margin-top }` no CSS global, que vale tambem para quem chega no site
 * ja com a ancora na URL — caso que nenhum handler de clique alcanca.
 */
export function scrollToAnchor(href: string): void {
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" })
}

/** Handler de clique para links de ancora, preservando o href no HTML. */
export function handleAnchorClick(
  event: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  onNavigate?: () => void,
): void {
  if (isExternalHref(href)) return

  event.preventDefault()
  onNavigate?.()
  scrollToAnchor(href)
}
